import { render, staticRenderFns } from "./SafetyModeRefreshAlert.vue?vue&type=template&id=04b8ad01&"
import script from "./SafetyModeRefreshAlert.vue?vue&type=script&lang=js&"
export * from "./SafetyModeRefreshAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../.yarn/$$virtual/vue-loader-virtual-add9cc88d1/0/cache/vue-loader-npm-15.9.0-dfd6801660-2.zip/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports